import React, { useEffect, useState } from 'react'
import { useLocation } from '@guillotinaweb/react-gmi'
import { Loading } from '@guillotinaweb/react-gmi'
import { useTraversal } from '@guillotinaweb/react-gmi'
import { diff, diffString } from 'json-diff'
import urljoin from 'urljoin'

const loadAuditlog = async (client, path, searchAfter) => {
  let endpoint = `@get-logs?path=${path}&size=20&backend=ch`
  if (searchAfter !== null) endpoint += `&search_after=${searchAfter}`
  const resp = await client.get(endpoint)
  const data = await resp.json()
  return [resp, data]
}

export const formatDateWithSeconds = (str) => {
  const d = new Date(str)
  const minutes = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes()
  const seconds = d.getSeconds() < 10 ? `0${d.getSeconds()}` : d.getSeconds()
  return `${d.getDate()}/${
    d.getMonth() + 1
  }/${d.getFullYear()} ${d.getHours()}:${minutes}:${seconds}`
}

function DiffViewser({ diffText, onClick }) {
  return (
    <div style={{ display: 'flex' }}>
      <pre
        className="is-marginless is-paddingless"
        style={{ whiteSpace: 'pre-wrap', flexGrow: 1 }}
      >
        {diffText.split('\n').map((l) => {
          if (l.startsWith('+'))
            return (
              <span style={{ backgroundColor: '#e6ffed' }}>{l + '\n'}</span>
            )
          else if (l.startsWith('-'))
            return (
              <span style={{ backgroundColor: '#ffeef0' }}>{l + '\n'}</span>
            )
          else return l + '\n'
        })}
      </pre>
      <div onClick={onClick} style={{ marginLeft: 'auto', padding: 5 }}>
        <i className="fas fa-arrow-down"></i>
      </div>
    </div>
  )
}

function AuditLogTab() {
  const Ctx = useTraversal()
  const { client } = Ctx
  const [url] = useLocation()
  const path = urljoin(client.rest.url, url.get('path'))

  const [logs, setLogs] = useState([])
  const [searchAfter, setSearchAfter] = useState(null)
  const [nextSearchAfter, setNextSearchAfter] = useState(null)

  const [isLoadingMore, setIsLoadingMore] = useState(true)
  const [selectedRow, setSelectedRow] = useState(null)

  useEffect(() => {
    async function load() {
      setIsLoadingMore(true)
      const [resp, data] = await loadAuditlog(client, path, searchAfter)
      if (resp.status === 200) {
        setLogs([...logs, ...data.logs])
        setNextSearchAfter(data.search_after)
      } else {
        Ctx.flash(`${resp.status} - ${JSON.stringify(data)}`, 'danger')
      }
      setIsLoadingMore(false)
    }
    load()
  }, [client, path, searchAfter])

  const atTheEnd = logs.length > 0 && searchAfter === nextSearchAfter

  const getPrevDoc = (i, arr, fallback) => {
    return i + 1 < arr.length ? arr[i + 1] : fallback
  }

  const getDetailedDiff = (doc, i, arr) => {
    const oldDoc = getPrevDoc(i, arr, doc).payload
    const newDoc = doc.payload
    return diffString(oldDoc, newDoc, { color: false })
  }

  const getDiffKeys = (doc, i, arr) => {
    const oldDoc = getPrevDoc(i, arr, doc).payload
    const newDoc = doc.payload
    return Object.keys(diff(oldDoc, newDoc) || {}).join(', ')
  }

  return (
    <div className={'table-container is-clipped'}>
      <table
        className={
          'table is-striped is-fullwidth is-small is-hoverable is-size-7'
        }
      >
        <colgroup>
          <col span="1" width="15%" />
          <col span="1" width="10%" />
          <col span="1" width="10%" />
          <col span="1" width="65%" />
        </colgroup>
        <thead>
          <tr>
            <th>Date</th>
            <th>User</th>
            <th>Action</th>
            <th>Payload</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((doc, i, arr) => (
            <tr key={doc.date}>
              <td>{formatDateWithSeconds(doc.date)}</td>
              <td>{doc.user}</td>
              <td>{doc.action}</td>
              <td>
                <DiffViewser
                  onClick={() =>
                    setSelectedRow(selectedRow === doc.date ? null : doc.date)
                  }
                  diffText={
                    selectedRow === doc.date
                      ? getDetailedDiff(doc, i, arr)
                      : getDiffKeys(doc, i, arr)
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {isLoadingMore && <Loading />}
      {!isLoadingMore && (
        <button
          className="button is-light is-small is-fullwidth"
          disabled={logs.length === 0 || atTheEnd}
          onClick={() => !atTheEnd && setSearchAfter(nextSearchAfter)}
        >
          {atTheEnd ? 'No more logs to load' : 'Load more'}
        </button>
      )}
    </div>
  )
}

export { AuditLogTab }
